import type NativeAdPlacement from '../store/schema/NativeAdPlacement';
import { getStore } from '../store/store';

/**
 * Returns true if ad is dismissed by user
 * @param adPlacement is the NativeAdPlacement enum
 * @param adPosition value 1 is for fixed ad, value 2 is for floating ad
 * @returns
 */
export default function shouldHideAd(adPlacement: NativeAdPlacement, adPosition: number) {
    const adList = getStore().adIds.filter(adId => adId.includes(adPlacement));
    const filteredAds = adList
        .map(adId => {
            const nativeAd = getStore().nativeAdRowStore.get(adId);
            return nativeAd.adPosition === adPosition ? nativeAd : null;
        })
        .filter(ad => ad);
    return filteredAds.length > 0 ? filteredAds[0].isDismissed : false;
}
